import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export const useEventTexts = () => {
  const intl = useIntl();

  const texts = useMemo(
    () => ({
      actions: {
        viewOnMap: intl.formatMessage({
          id: 'learner.common.event.viewOnMap',
        }),
        join: intl.formatMessage({
          id: 'learner.common.event.join',
        }),
      },
      toasts: {
        resendInvitationSuccess: intl.formatMessage({
          id: 'learner.common.event.resendInvitation.success.toast',
        }),
        resendInvitationError: intl.formatMessage({
          id: 'learner.common.event.resendInvitation.error.toast',
        }),
        attendanceError: intl.formatMessage({
          id: 'learner.common.event.attendance.error.toast',
        }),
      },
      tags: {
        optional: intl.formatMessage({
          id: 'learner.common.optional',
        }),
        pin: intl.formatMessage({
          id: 'learner.common.event.tags.pin',
        }),
        pastEvent: intl.formatMessage({
          id: 'learner.common.event.tags.pastEvent',
        }),
        completion_status_completed: intl.formatMessage({
          id: 'learner.common.event.tags.completionStatusCompleted',
        }),
        completion_status_completed_passed: intl.formatMessage({
          id: 'learner.common.event.tags.completionStatusCompletedPassed',
        }),
        completion_status_completed_awaiting_evaluation: intl.formatMessage({
          id: 'learner.common.event.tags.completionStatusCompletedAwaitingEvaluation',
        }),
        completion_status_completed_failed: intl.formatMessage({
          id: 'learner.common.event.tags.completionStatusCompletedFailed',
        }),
        completion_status_not_completed: intl.formatMessage({
          id: 'learner.common.event.tags.completionStatusIncomplete',
        }),
        completion_status_unknown: intl.formatMessage({
          id: 'learner.common.event.tags.completionStatusUnknown',
        }),
      },
      attendance: {
        accepted: intl.formatMessage({
          id: 'learner.common.event.attendance.accepted',
        }),
        tentative: intl.formatMessage({
          id: 'learner.common.event.attendance.tentative',
        }),
        declined: intl.formatMessage({
          id: 'learner.common.event.attendance.declined',
        }),
      },
      attendanceGroupAriaLabel: intl.formatMessage({
        id: 'learner.common.event.attendance.groupAriaLabel',
      }),
      resendInvitation: intl.formatMessage({
        id: 'learner.common.event.resendInvitation',
      }),
      moreActions: intl.formatMessage({
        id: 'learner.common.event.moreActions',
      }),
      eventDate: intl.formatMessage({
        id: 'learner.common.event.date',
      }),
      virtualEvent: intl.formatMessage({
        id: 'learner.common.event.type.ev_virtual',
      }),
      phoneConferenceEvent: intl.formatMessage({
        id: 'learner.common.event.type.ev_call',
      }),
    }),
    [intl],
  );

  return texts;
};
